module.exports = __webpack_public_path__ + "img/data-active.6cb623bf.svg";